export class Campaign {
    id:string;
    commercialId:number;
    name:string;
    voucherCount:number;
    voucherConsumed:number;
    creationDate:Date;
    startDate:any;
    endDate:any;
    country:string;
    countryName:string;
    canal:string;
    value:string;
    valueType:string;
    valueAmount:number;
    valuePercentage:number;
    combinable:boolean;
    products:any;
    status:string;

    constructor(campaign:any) {
        this.id = campaign.id;
        this.commercialId = campaign.commercialId;
        this.name = campaign.name;
        this.voucherCount = campaign.voucherCount;
        this.voucherConsumed = campaign.voucherConsumed;
        this.creationDate = campaign.creationDate;
        this.startDate = campaign.startDate;
        this.endDate = campaign.endDate;
        this.country = campaign.country;
        this.countryName = campaign.countryName;
        this.canal = campaign.canal;
        this.value = campaign.value;
        this.combinable = campaign.combinable;
        this.products = campaign.products;
        this.status = campaign.status;
        if (this.value !== undefined) {
            this.setValueType();
        }
    }

    setValue() {
        if (this.valueType === "free") {
            this.value = "FREE";
        } else if (this.valueType === "percentage") {
            this.value = this.valuePercentage + "%";
        } else if (this.valueType === "amount") {
            this.value = this.valueAmount.toString();
        }
    }


    setValueType() {
        if (this.value.toUpperCase() === "FREE") {
            this.valueType = "free";
        } else if (this.value.indexOf("%") >= 0) {
            this.valueType = "percentage";
            this.valuePercentage = Number.parseFloat(this.value.replace("%", ""));
        } else {
            this.valueType = "amount";
            this.valueAmount = Number.parseFloat(this.value);
        }
    }

    hasStarted():boolean {
        return this.voucherConsumed > 0;
    }


}